import { NgModule } from '@angular/core';
import { PcPlatformService } from 'app/shared/services/platform/platform.service';

@NgModule({
  providers: [PcPlatformService],
})
export class PcPlatformModule {
  /**
   * Constructor
   */
  constructor(private _pcPlatformService: PcPlatformService) {}
}
